import { Directive, ElementRef, Renderer, Input } from '@angular/core';
import { PermissionsProviderService } from '../services/permissions-provider.service';

@Directive({
  selector: '[appAuthShow]'
})
export class AuthShowDirective {

  @Input() authShow: string;

  constructor(el: ElementRef, renderer: Renderer, permissionsService: PermissionsProviderService) {
    renderer.setElementStyle(el.nativeElement, 'display', 'none');
    if (this.authShow != '') {
      var conditionExecuter = function () { renderer.setElementStyle(el.nativeElement, 'display', 'block');};
      permissionsService.checkAuthorityAndExecuteCommand(this.authShow, conditionExecuter, null, null);
    }
  }

}
